import React from 'react';

class CreateChannel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: !props.width ? 16 : props.width,
      height: !props.height ? 14.222 : props.height,
      color: !props.color ? '#fff' : props.color,
    };
  }

  render() {
    return (
      <svg
        className={this.props.className}
        xmlns="http://www.w3.org/2000/svg"
        width={this.state.width}
        height={this.state.height}
        viewBox={`0 0 ${this.state.width} ${this.state.height}`}>
        <path
          id="gem-solid"
          d="M13.486,0,16,4.444H13.192L11.269,0ZM9.931,0l1.922,4.444H4.147L6.069,0ZM2.514,0H4.731L2.808,4.444H0ZM0,5.333H2.8l3.417,6.992a.084.084,0,0,1-.139.092Zm4.117,0h7.767L8.078,14.172a.083.083,0,0,1-.153,0Zm5.669,6.992L13.2,5.333H16L9.925,12.414a.083.083,0,0,1-.139-.089Z"
          fill={this.state.color}
        />
      </svg>
    );
  }
}

export default CreateChannel;
